// i18n.ts
"use client";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      supportedLngs: ["en", "fr", "ar"],
      fallbackLng: "en",
      defaultNS: "common",
      ns: ["common"],
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
      },
      detection: {
        order: ["path", "cookie", "localStorage", "navigator"],
        caches: ["cookie"],
      },
      react: { useSuspense: false },
      // debug: true, // Enable debug mode to get detailed logs
    },
    (err) => {
      if (err) console.error("i18n initialization failed:", err);
    },
  );

export default i18n;
